const Currency = () => '$';

export default Currency;
